import { render } from "./inpatient_setting.vue?vue&type=template&id=3b366958&scoped=true"
import script from "./inpatient_setting.vue?vue&type=script&lang=js"
export * from "./inpatient_setting.vue?vue&type=script&lang=js"

import "./inpatient_setting.vue?vue&type=style&index=0&id=3b366958&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b366958"]])

export default __exports__